import React from 'react'
import PropTypes from 'prop-types'

import Queues from 'components/queues/queues'
import SiteName from './site-name'
import WarmingControls from './warm-controls'


const Sidebar = ({ site, match: { params: { queueId } } }) => {
  if (!site) {
    return null
  }

  return (
    <div className="site-sidebar mb-4">
      <SiteName currentQueueId={ queueId } site={ site }/>
      <WarmingControls site={ site }/>
      <Queues currentQueueId={ queueId } site={ site }/>
    </div>
  )
}

Sidebar.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      queueId: PropTypes.string,
    }).isRequired,
  }).isRequired,
  site: PropTypes.object,
}

export default Sidebar



// WEBPACK FOOTER //
// ./src/components/sites/sidebar/index.js